module.exports = __webpack_public_path__ + "img/미스트.7fba0670.png";